import './application.css'
import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'
import AuthModalController from '../controllers/auth_modal_controller'

const application = Application.start()
application.register('auth-modal', AuthModalController)
